<script>
  import GalerieImages from '@/components/GalerieImages.vue'
  export default {
    name: 'Sculptures',
    data() {
      return {
        sculptures: [],
      }
    },
    mounted() {
      this.InitialiserDonnees()
    },
    methods: {
      async InitialiserDonnees() {
        const donneesBase = await fetch(
          'https://pascalchove.com/SculpturesService.php'
        )
        this.sculptures = await donneesBase.json()
        this.sculptures = this.sculptures.sort((a, b) => b.ordre - a.ordre)
      },
    },
    computed: {
      sculpturesAAfficher() {
        return this.sculptures
      },
    },
    components: {
      GalerieImages,
    },
  }
</script>

<template>
  <h2>LES SCULPTURES</h2>

  <GalerieImages :donnees="sculpturesAAfficher" categorie="sculptures" />
</template>
